// context/AudioPlayerContext.jsx
import React, { createContext, useContext, useState } from 'react';

const AudioPlayerContext = createContext();

export const AudioPlayerProvider = ({ children }) => {
  const [audioData, setAudioData] = useState(null); // { src, title, excerpt }
  const [isPlaying, setIsPlaying] = useState(false);
  const [showPlayer, setShowPlayer] = useState(false);

  const playAudio = ({ src, title, excerpt, toggle = false }) => {
    if (toggle && audioData?.src === src) {
      setIsPlaying(prev => !prev); // ← This handles the toggle play/pause
    } else {
      setAudioData({ src, title, excerpt });
      setIsPlaying(true);
      setShowPlayer(true);
    }
  };
  
  const pauseAudio = () => {
    setIsPlaying(false);
    setAudioData(null);
    setShowPlayer(false);
  };
//   const pauseAudio = () => setIsPlaying(false);

  const closeAudio = () => {
    setAudioData(null);
    setIsPlaying(false);
  };

  return (
    <AudioPlayerContext.Provider
      value={{ audioData, isPlaying, setIsPlaying, playAudio, pauseAudio, closeAudio }}
    >
      {children}
    </AudioPlayerContext.Provider>
  );
};

export const useAudioPlayer = () => useContext(AudioPlayerContext);
